<template>
    <div id="main">
        <router-view v-wechat-title="$t('title')"></router-view>
        <loading></loading>
    </div>
</template>
<script>
    require('./assets/css/template.css');
    import {mapState} from 'vuex'
    import loading from '@/view/module/Loading.vue'

    export default {
        name: "App",
        computed: {
            ...mapState(['locale'])
        },
        components: {loading},
        data() {
            return {}
        },
        mounted() {
            this.$i18n.locale = this.locale;
        },
    }
</script>
